class SearchField extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector(".search-field__input");
    this.clearButton = this.querySelector(".search-field__clear");
    this.changeEvent = new Event("change", { bubbles: true });
    this.inputEvent = new Event("input", { bubbles: true });

    if (!this.input || !this.clearButton) return;

    this.input.addEventListener("input", this.updateState.bind(this));

    this.clearButton.addEventListener("click", this.onClearClick.bind(this));

    this.updateState();
  }

  updateState() {
    this.classList.toggle(
      "search-field--active",
      this.input.value.trim().length > 0
    );
  }

  onClearClick(event) {
    event.preventDefault();

    if (!this.input.value) {
      this.input.focus();
      return;
    }

    this.input.value = "";
    this.updateState();
    this.input.focus();

    this.input.dispatchEvent(this.inputEvent);
    this.input.dispatchEvent(this.changeEvent);
  }
}

if (!customElements.get("search-field")) {
  customElements.define("search-field", SearchField);
}